export default function (vehicleId, getVehicle) {
    return getVehicle(vehicleId)
    .then(data => ({data}));
}



// WEBPACK FOOTER //
// ./Client/app/common/letterTemplates/last-keeper-signed/getLastKeeperSignedModel.js